import Popup from './_popup.js'
import Button from './_button.js'
import Text from './_text.js'
import AbsolutePane from './_absolute-pane.js'
import Image from './_image.js'
import ImageButton from './_image-button.js'

export default {
  name: 'Tooltip',
  values: {
    showCloseButton: true,
    popup: {
      configSet: Popup,
      configValues: {
        captureOutsideClicks: false,
        container: {
          style: {
            width: '280px',
          },
        },
        content: {
          style: {
            base: {
              alignItems: 'center',
              padding: '0px',
            },
          },
        },
        arrowheadOffset: '122px',
      },
    },
    clickableContainer: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            padding: '16px',
            gap: '8px',
          },
        },
      },
    },
    textLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 8px 0 0',
        },
      },
    },
    closeButtonContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          right: 0,
          top: 0,
        },
      },
    },
    image: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '40px',
          minHeight: '40px',
          padding: '0 8px 0 0',
        },
      },
    },
    closeButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              alignItems: 'center',
              flexBasis: '32px',
              minWidth: '32px',
              minHeight: '32px',
            },
          },
        },
        buttonIcon: {
          src: 'close',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
